import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { useAuth } from '../context/AuthContext.jsx';
import { formatDateTime } from '../utils/formatDate.js';

export function AdminAnnouncementsPanel() {
  const { user } = useAuth();
  const caps = user?.capabilities ?? {};
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () =>
    apiJson('/api/admin/announcements')
      .then(setItems)
      .catch((e) => setError(e.message));

  useEffect(() => {
    if (caps.manage_announcements) void load();
  }, [caps.manage_announcements]);

  if (!caps.manage_announcements) return null;

  const publish = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await apiJson('/api/admin/announcements', {
        method: 'POST',
        body: { title: title.trim(), body: body.trim() || null },
      });
      setTitle('');
      setBody('');
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    await apiJson(`/api/admin/announcements/${id}`, { method: 'DELETE' });
    await load();
  };

  return (
    <div className="auth-card flat" style={{ marginTop: '1rem' }} data-tour="dashboard-announcements">
      <h3>Company news</h3>
      <form onSubmit={publish} className="stack">
        <label className="field">
          <span>Title</span>
          <input value={title} onChange={(e) => setTitle(e.target.value)} required />
        </label>
        <label className="field">
          <span>Body</span>
          <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={3} />
        </label>
        <button type="submit" className="btn-secondary" disabled={busy}>
          {busy ? 'Publishing…' : 'Publish announcement'}
        </button>
      </form>
      {error ? <p className="err">{error}</p> : null}
      {items.length ? (
        <ul className="list-plain" style={{ marginTop: '1rem' }}>
          {items.map((a) => (
            <li key={a.id} className="row-actions" style={{ justifyContent: 'space-between' }}>
              <span>
                <strong>{a.title}</strong>
                <span className="muted small"> · {formatDateTime(a.published_at)}</span>
              </span>
              <button type="button" className="btn-link" onClick={() => void remove(a.id)}>
                Delete
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
